var _path, _path2, _path3, _path4, _circle, _path5, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVinylLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 254 254",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m252 127a125 125 0 1 0 -125 125 125 125 0 0 0 125-125z",
    fill: "#555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m252 127a125 125 0 1 0 -125 125 125 125 0 0 0 125-125z",
    fill: "none",
    stroke: "#222",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m164.5 127a37.5 37.5 0 1 0 -37.5 37.5 37.5 37.5 0 0 0 37.5-37.5z",
    fill: "#004fc1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m164.5 127a37.5 37.5 0 0 0 -2.14-12.5h-70.72a37.5 37.5 0 1 0 72.86 12.5z",
    fill: "#3c80f8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 127,
    cy: 127,
    fill: "none",
    r: 30,
    stroke: "#222",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m123.25 127a3.75 3.75 0 1 1 3.75 3.75 3.75 3.75 0 0 1 -3.75-3.75z",
    fill: "#222"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#ddd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m155.85 35.48a96.42 96.42 0 0 0 -57.7 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148 60.44a70.17 70.17 0 0 0 -42 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.56 49.44a109.7 109.7 0 0 0 -155.12 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.15 218.52a96.42 96.42 0 0 0 57.7 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106 193.56a70.17 70.17 0 0 0 42 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.44 204.56a109.7 109.7 0 0 0 155.12 0"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#222"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35.48 98.15a96.42 96.42 0 0 0 0 57.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.44 106a70.17 70.17 0 0 0 0 42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.07 68.07a83.34 83.34 0 0 0 0 117.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.52 155.85a96.42 96.42 0 0 0 0-57.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.56 148a70.17 70.17 0 0 0 0-42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.93 185.93a83.34 83.34 0 0 0 0-117.86"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinylLoading);
export default __webpack_public_path__ + "static/media/vinyl_loading.3c407cc3398354a755757db8737c2c9e.svg";
export { ForwardRef as ReactComponent };